import React, { useState } from 'react'
import styles from '../../../Assets/Styles/Components/Book/Photograpers/equipment.module.css'
import cam from '../../../Assets/Images/Equipment/camera.svg'
import lens from '../../../Assets/Images/Equipment/lens.svg'
import light from '../../../Assets/Images/Equipment/flash.svg'

const Equipment = (props: any) => {
  const [show, setShow] = useState(false)
  const { eq, name } = props

  const showBox = () => {
    setShow(!show)
  }

  const eqsNumber = () => {
    let num = 0
    eq?.cameras && eq?.cameras?.length > 0 && (num = num + eq.cameras.length)
    eq?.lenzs && eq?.lenzs?.length > 0 && (num = num + eq.lenzs.length)
    eq?.lights && eq?.lights?.length > 0 && (num = num + eq.lights.length)
    return num
  }

  return (
    <>
      <div className={styles.thumbnails} onClick={showBox}>
        {eq?.cameras?.length > 0 && (
          <div className={styles.eqImage}>
            <img className={styles.eqImageTag} src={cam} alt='cam' />
          </div>
        )}
        {eq?.lenzs?.length > 0 && (
          <div className={styles.eqImage}>
            <img className={styles.eqImageTag} src={lens} alt='lens' />
          </div>
        )}
        {eq?.lights?.length > 0 && (
          <div className={styles.eqImage}>
            <img className={styles.eqImageTag} src={light} alt='light' />
          </div>
        )}
        {eqsNumber() > 3 && (
          <div className={styles.exImages}>
            <b> مشاهده  تجهیزات</b>
          </div>
        )}
      </div>
      <div className={`${styles.equipments} ${show ? styles.show : ''}`}>
        <div
          className={styles.container}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <div className={styles.title}>
            <div className={styles.titleName}>
              تجهیزات <b>{name}</b>
            </div>
            <div className={styles.closeBtn} onClick={showBox} />
          </div>
          <div className={styles.content}>
            <div className='container'>
              {props.eq?.cameras ? (
                <div className='row'>
                  <div className={`col-12  ${styles.item}`}>
                    <h4>دوربین</h4>
                    <div className='row align-items-center justify-content-center'>
                      <div
                        className={`col-3 d-flex  align-items-center justify-content-center `}
                      >
                        <img src={cam} alt='' />
                      </div>
                      <div className='col-9'>
                        {eq.cameras?.map((c: string, key: number) => (
                          <p key={key}>{c}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {props.eq?.lenzs ? (
                <div className='row'>
                  <div className={`col-12 ${styles.item}`}>
                    <h4>لنز</h4>
                    <div className='row align-items-center justify-content-center'>
                      <div
                        className={`col-3 d-flex  align-items-center justify-content-center `}
                      >
                        <img src={lens} alt='' />
                      </div>
                      <div className='col-9'>
                        {eq.lenzs?.map((l: string, key: number) => (
                          <p key={key}>{l}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {props.eq?.lights ? (
                <div className='row'>
                  <div className={`col-12  ${styles.item}`}>
                    <h4>تجهیزات نوری</h4>
                    <div className='row align-items-center justify-content-center'>
                      <div
                        className={`col-3 d-flex  align-items-center justify-content-center `}
                      >
                        <img src={light} alt='' />
                      </div>
                      <div className='col-9'>
                        {props.eq?.lights?.length && props.eq?.lights?.map((l: any, key: number) => {
                          return (
                            <div className='row' key={l.title + key}>
                              <div className='col-12'>
                                <p key={key}>{l.title}</p>
                              </div>
                              <div className='col-12'>
                                {l?.items && l.items.map((i: string, index: number) => (
                                  <p key={index} className='col-12'>
                                    + {i}
                                  </p>
                                ))}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.bottomBar}>
            <div className='container'>
              <div className='row'>
                <div className={`col-12 ${styles.btn}`} onClick={showBox}>
                  بستن
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Equipment
